import React from "react";
import styled from "styled-components";

import { ITeamMemberFields } from "src/types/generated/contentful";

import CardLayout from "./Layouts/CardLayout";
import PageLayout from "./Layouts/PageLayout";
import BobLayout from "./Layouts/BobLayout";

const CellWrapper = styled.div`
  padding: 1em;
`;

type TeamMemberProps = { "data-layoutid"?: string } & ITeamMemberFields;

export default function TeamMember(data: TeamMemberProps): JSX.Element {
  //console.log("TeamMember", JSON.stringify(data));
  const layout = data["data-layoutid"] || "";
  let returnNode = <div />;
  // if L then return the whole page, else return the small card
  if (layout === "L") {
    returnNode = <PageLayout {...data} />;
  } else if (layout.toLowerCase().indexOf("medicare-bob") >= 0) {
    returnNode = <BobLayout {...data} />;
  } else {
    returnNode = <CardLayout {...data} />;
  }

  return returnNode;
}
